// Checkbox.js
import React from 'react';

const Checkbox = ({ label, checked, onChange, disabled = false,name }) => {
  return (
    <label style={{ display: 'flex',height:'45px', alignItems: 'center', gap: '8px', cursor: disabled ? 'not-allowed' : 'pointer' }}>
      <input
        type="checkbox"
        checked={checked}
        name={name}
        onChange={onChange}
        disabled={disabled}
        style={{ width: '16px', height: '16px' }}
      />
      <span>{label}</span>
    </label>
  );
};

export default Checkbox;
